<tiime-input-container
  tiimeFormInputContainer
  contentId="centralizer-pcg-entry"
  [small]="small"
  [required]="required"
  [label]="label"
  [errorMessage]="errorMessage"
>
  <tiime-select
    id="centralizer-pcg-entry"
    class="selected"
    [required]="required"
    [formControl]="ctrl"
    (closeOptionsPanel)="closeOptionsPanel()"
    data-cy="centralizer-pcg-entry-select"
  >
    @if (selectorData?.length > 0) {
      <input
        tiimeSelectInput
        placeholder="Rechercher un compte"
        [formControl]="searchControl"
        appFormFocusObserve
        (formChanges)="searchControlChanges()"
      />
    }
    <div tiimeSelectOptions>
      @if (!searchControl.value) {
        <mat-option [value]="null" (onSelectionChange)="selectEmptyOption($event)">
          Aucun compte centralisateur
        </mat-option>
      }
      @for (
        pcgEntry of filteredSelectorData | pcgEntriesWithoutArchived: ctrl.value : searchControl.value;
        track trackById($index, pcgEntry)
      ) {
        <mat-option
          [disabled]="pcgEntry.archived"
          [value]="pcgEntry.id"
          (onSelectionChange)="emitSelectChange($event, pcgEntry)"
        >
          <app-pcg-entry-option [pcgEntry]="pcgEntry"></app-pcg-entry-option>
        </mat-option>
      }
      <mat-option (onSelectionChange)="openCreateCentralizerPcgEntryDialog($event)">
        <div class="create-option-content">
          <mat-icon fontSet="fontastic" fontIcon="icon-add-fontastic"></mat-icon>
          <span>Ajouter un compte centralisateur</span>
        </div>
      </mat-option>
    </div>
  </tiime-select>
</tiime-input-container>
